// extracted by mini-css-extract-plugin
export default {"actions":"PermissionScopingDemo_actions__xdUY9","skipped":"PermissionScopingDemo_skipped__DY5hp","enableLink":"PermissionScopingDemo_enableLink__B1o+W"};